import { Pipe, PipeTransform } from '@angular/core';
import { translation } from '@cue/translations';
import { ResourceAssignType } from '@cue/api';

@Pipe({
  name: 'assignToTranslateKey',
  standalone: true,
})
export class AssignToTranslateKeyToPipe implements PipeTransform {
  transform(assignTo: ResourceAssignType): string {
    switch (assignTo) {
      case ResourceAssignType.Mine:
        return translation.outlookAddin.assignedMine;
      case ResourceAssignType.Ours:
        return translation.outlookAddin.assignedOurs;
      case ResourceAssignType.Restricted:
        return translation.outlookAddin.assignedRestricted;
      case ResourceAssignType.Free:
        return translation.outlookAddin.assignedFree;
      default:
        return '';
    }
  }
}
